import { useMemo, useRef } from 'react';

type UseEmptyFolderGateParams = {
  shouldShowEmpty: boolean;
  childrenKnown: boolean;
  childCount: number;
  isSelectingFromList: boolean;
  suppressEmptyUntilTs: number;
  stableWindowMs?: number;
};

export function useEmptyFolderGate({
  shouldShowEmpty,
  childrenKnown,
  childCount,
  isSelectingFromList,
  suppressEmptyUntilTs,
  stableWindowMs = 350,
}: UseEmptyFolderGateParams): boolean {
  const emptyStableSinceRef = useRef<number | null>(null);

  return useMemo(() => {
    const now = Date.now();
    // Do not suppress when children are known-empty
    const clickSuppressed =
      (childCount !== 0 && now <= suppressEmptyUntilTs) || isSelectingFromList;

    const candidateEmpty = shouldShowEmpty && childrenKnown && childCount === 0 && !clickSuppressed;

    if (candidateEmpty) {
      if (emptyStableSinceRef.current == null) {
        emptyStableSinceRef.current = now;
      }
      if (now - (emptyStableSinceRef.current || now) >= stableWindowMs) {
        return true;
      }
    } else {
      emptyStableSinceRef.current = null;
    }
    return false;
  }, [
    shouldShowEmpty,
    childrenKnown,
    childCount,
    isSelectingFromList,
    suppressEmptyUntilTs,
    stableWindowMs,
  ]);
}
